import styled from 'styled-components';
import { EMAIL_SENT } from '../../config/media';
const Wrapper = styled.div`
	width: 100%;

	height: auto;
	box-sizing: border-box;
	padding: 20px;

	h2 {
		font-family: HaasGrotDisp, -apple-system, system-ui;
		font-weight: bold;
		font-size: 24px;
		text-align: center;
		margin-bottom: 22px;
		color: #FFFFFF;
	}

	p {
		margin-top: 12px;
		margin-bottom: 16px;
		color: #9b9b9b;
	}
	.ant-input {
		border: none !important;
        border-radius: 0%;
    }
	.ant-btn-primary {
		font-weight: normal !important;
		background-color: #3A4FFF;
	}
	.instructions {
		background-color: #212121;
		width: 90%;
		color: #A8A8B1;
		margin: auto;
		padding: 12px;
		padding-left: 52px;
		margin-bottom: 22px;
		background-image: url(${EMAIL_SENT});
		background-size: 22px;
		background-position: 18px center;
		background-repeat: no-repeat;
	}
	.btn-area {
		margin-top: 12px;
		margin-bottom: 12px;
	}
	.link {
		text-align: center;
		a {
			font-size: 12px;
			text-decoration: none;
			color: #3A4FFF;
		}
	}
	.ant-input:hover {
    border: 1px solid rgb(167 168 177 / 50%) !important;
	}
	.ant-input:focus{
		border: 1px solid #3A4FFF !important;
	}
`;

export default Wrapper;
